export default Object.assign(() => {
}, { __unenv__: true });
